import {
  BarChartOutlined,
  FileTextOutlined,
  FireOutlined,
  FormOutlined,
  GiftOutlined,
  LineChartOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import i18n from "translations/i18n";
import urls from "urls";

const shopNavTree = [
  {
    key: "shop",
    title: "Fulfillment",
    breadcrumb: false,
    submenu: [
      {
        key: "shop-orders",
        path: urls.ordersList,
        title: i18n.t("order.orders"),
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
  {
    key: "shop-reports",
    title: i18n.t("reports"),
    icon: LineChartOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "shop-reports-dashboard",
        path: urls.reports,
        title: i18n.t("sales_dashboard"),
        icon: "",
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: "shop-reports-products",
      //   path: urls.reportsProducts,
      //   title: i18n.t("sales_products"),
      //   icon: "",
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: "shop-reports-customer-segments",
      //   path: urls.reportsCustomerSegments,
      //   title: i18n.t("customer_segments"),
      //   icon: "",
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: "shop-reports-rfm",
      //   path: urls.rfmAnalysis,
      //   title: i18n.t("rfm_analysis"),
      //   icon: "",
      //   breadcrumb: false,
      //   submenu: [],
      // },
      // {
      //   key: "shop-reports-loyalty",
      //   path: urls.reportsLoyalty,
      //   title: i18n.t("loyalty_reports"),
      //   icon: "",
      //   breadcrumb: false,
      //   submenu: [],
      // },
    ],
  },
];

const navigationConfig = [...shopNavTree];

export default navigationConfig;
